import { render, staticRenderFns } from "./CatergoryNavMobile.vue?vue&type=template&id=10b31a3a&"
import script from "./CatergoryNavMobile.vue?vue&type=script&lang=js&"
export * from "./CatergoryNavMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports